import { useAppSelector } from './redux';

/** Есть ли у психолога результаты выбора карт МАК (свой выбор клиента или выборы участников группы). */
export const useMacHasResults = (): boolean =>
  useAppSelector(
    (state) =>
      state.macStateSlice.selected.length > 0 ||
      Object.keys(state.macStateSlice.clientSelectionsByParticipant).length > 0,
  );
